import { useEffect, useState } from "react";
import api from "../constant/api";
import { motion, AnimatePresence } from "framer-motion";
import { pdf } from "@react-pdf/renderer";
import QuotationPDF from "./QuotationPDF";
import { X } from "lucide-react";
import InvoicePDF from "./InvoicePDF";

export default function Order() {

  const [orders, setOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [tempSearch, setTempSearch] = useState(""); // ✅ mobile filter fix
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);

  const [fullOrder, setFullOrder] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [vehicleNo, setVehicleNo] = useState("");


  const [showInvoiceModal,setShowInvoiceModal]=useState(false);

const [invoiceItems,setInvoiceItems]=useState([]);

 const user = JSON.parse(localStorage.getItem("user") || "{}");

const user_id = user.user_id;

const [gst,setGst]=useState(18);

  const itemsPerPage = 5;


  const [showReturnModal, setShowReturnModal] = useState(false);

const [returnItem, setReturnItem] = useState(null);

const [returnQty, setReturnQty] = useState("");

const [returnPcs, setReturnPcs] = useState("");

  const handleSelectItem = (product_id) => {

  setSelectedItems((prev) => {

    if (prev.includes(product_id)) {
      return prev.filter(id => id !== product_id);
    }

    return [...prev, product_id];

  });

};

const [statusFilter, setStatusFilter] =
  useState("All");

const filteredOrders = orders
  .filter((o) => {

    // STATUS FILTER
    if (
      statusFilter === "Pending"
    ) {
      return (
        !o.status ||
        o.status === "Pending"
      );
    }

    if (
      statusFilter !== "All"
    ) {
      return (
        o.status ===
        statusFilter
      );
    }

    return true;

  })
  .filter((o) =>
    o.name
      ?.toLowerCase()
      .includes(
        search.toLowerCase()
      )
  );

const handleInvoicePrint =
  async (invoice_id) => {

    const res =
      await api.get(
        `/order/getInvoice/${invoice_id}`
      );

    const blob =
      await pdf(

        <InvoicePDF
          invoice={
            res.data.invoice
          }
          items={
            res.data.items
          }
        />

      ).toBlob();

    const url =
      URL.createObjectURL(
        blob
      );

    window.open(url);

};
//   const createInvoice = async (order_id) => {

//   try {

//     const ok = window.confirm(
//       "Create Invoice for this Order?"
//     );

//     if (!ok) return;

//     const res = await api.post(
//       `/order/createInvoice/${order_id}`
//     );

//     alert(res.data.message);

//     // Refresh Orders
//     const orderRes = await api.get(
//       "/order/getAllOrders"
//     );

//     setOrders(orderRes.data.data || []);

//     // Refresh Current Modal
//     const detailRes = await api.get(
//       `/order/getFullOrderDetails/${order_id}`
//     );

//     setFullOrder(detailRes.data);

//   } catch (err) {

//     console.log(err);

//     alert(
//       err?.response?.data?.message ||
//       "Invoice Create Failed"
//     );

//   }

// };



const createInvoice = async (
  order_id,
  items,
  gst,
  vehicleNo
) => {

  try {
     console.log('items',items)
    const subtotal = items.reduce(
      (a, b) =>
        a +
        Number(b.qty) *
        Number(b.price),
      0
    );

    const gstAmount =
      subtotal * Number(gst) / 100;

    const cgst =
      gstAmount / 2;

    const sgst =
      gstAmount / 2;

    const netTotal =
      subtotal + gstAmount;

    const res = await api.post(
      `/order/createInvoice/${order_id}`,
      {
        items,
        subtotal,
        gst,
        gstAmount,
        cgst,
        sgst,
        netTotal,
        vehicleNo,
        salesman_id:user_id
      }
    );

    alert(res.data.message);

    setShowInvoiceModal(false);

    const orderRes =
      await api.get("/order/getAllOrders");

    setOrders(orderRes.data.data || []);

  } catch (err) {

    console.log(err);

  }

};
const confirmOrder = async (order_id) => {

  try {

    if (selectedItems.length === 0) {
      alert("Select products");
      return;
    }

    const ok = window.confirm(
      "Confirm selected products?"
    );

    if (!ok) return;

    // 🔥 GET FULL ORDER
    const res = await api.get(
      `/order/getFullOrderDetails/${order_id}`
    );

    const items = res.data.items || [];

    // 🔥 LOOP PRODUCTS
    for (let item of items) {

      // ONLY SELECTED
      if (
        !selectedItems.includes(
          item.product_id
        )
      ) continue;

      // 🔥 GET PRODUCT
      const productRes = await api.post(
        "/Product/getProductByid",
        {
          product_id: item.product_id
        }
      );

      // 🔥 PRODUCT DATA
      const product =
        productRes?.data?.data?.[0];

      if (!product) {

        alert(
          `Product not found ID: ${item.product_id}`
        );

        return;

      }

      // 🔥 PCS PER BOX
      const pcsPerBox =
        parseInt(
          product?.pcs_per_box || 0
        );

      // 🔥 STOCK
      const stockBox =
        parseInt(
          product?.qty || 0
        );

      const stockPcs =
        parseInt(
          product?.pic || 0
        );

      // 🔥 ORDER
      const orderBox =
        parseInt(
          item?.qty || 0
        );

      const orderPcs =
        parseInt(
          item?.pcs || 0
        );

      // 🔥 TOTAL STOCK PCS
      const stockTotalPcs =
        (stockBox * pcsPerBox) +
        stockPcs;

      // 🔥 TOTAL ORDER PCS
      const orderTotalPcs =
        (orderBox * pcsPerBox) +
        orderPcs;

      // 🔥 BALANCE PCS
      const balancePcs =
        stockTotalPcs -
        orderTotalPcs;

      // 🔥 VALIDATION
      if (balancePcs < 0) {

        alert(
          `${product.product_name} stock not enough`
        );

        return;

      }

      // 🔥 FINAL BOX
      const finalBox =
        Math.floor(
          balancePcs / pcsPerBox
        );

      // 🔥 FINAL PCS
      const finalPcs =
        balancePcs % pcsPerBox;

      console.log({
        product: product.product_name,
        stockBox,
        stockPcs,
        orderBox,
        orderPcs,
        finalBox,
        finalPcs
      });

      // 🔥 UPDATE STOCK
      await api.post(
        `/Product/updateStock/${item.product_id}`,
        {
          qty: finalBox,
          pic: finalPcs
        }
      );

    }

    // 🔥 CONFIRM ORDER
    await api.post(
      `/order/confirmOrder/${order_id}`,
      {
        products: selectedItems
      }
    );

    alert(
      "✅ Products Confirmed & Stock Updated"
    );

    // 🔥 REFRESH ORDER
    const orderRes =
      await api.get(
        "/order/getAllOrders"
      );

    setOrders(
      orderRes.data.data || []
    );

    // 🔥 RESET
    setSelectedItems([]);

    setFullOrder(null);

  } catch (err) {

    console.log(err);

    alert("❌ Failed");

  }

};

  // 🔥 FETCH
  useEffect(() => {
    api.get("/order/getAllOrders")
      .then(res => setOrders(res.data.data || []))
      .catch(err => console.log(err));
  }, []);

  // 🔍 SEARCH
 
  // 📄 PAGINATION
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

  // 🔥 VIEW MODAL
  const openOrderDetails = (order_id) => {
    api.get(`/order/getFullOrderDetails/${order_id}`)
      .then(res => setFullOrder(res.data))
      .catch(err => console.log(err));
  };

  // 🔥 PDF OPEN (BEST METHOD)
  const handlePrint = async (order_id) => {
    try {
      const res = await api.get(`/order/getFullOrderDetails/${order_id}`);
      const blob = await pdf(
        <QuotationPDF
          order={res.data.order}
          items={res.data.items}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      window.open(url); // ✅ mobile friendly
    } catch (err) {
      console.log(err);
    }
  };

  const getPagination = (currentPage, totalPages) => {
  const pages = [];

  if (totalPages <= 7) {
    // show all pages
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    pages.push(1); // always show first

    if (currentPage > 3) {
      pages.push("...");
    }

    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - 2) {
      pages.push("...");
    }

    pages.push(totalPages); // always show last
  }

  return pages;
};

const handleShare = async (order_id) => {

  try {

    const res = await api.get(
      `/order/getFullOrderDetails/${order_id}`
    );

    const blob = await pdf(
      <QuotationPDF
        order={res.data.order}
        items={res.data.items}
      />
    ).toBlob();

    const file = new File(
      [blob],
      `Quotation-${order_id}.pdf`,
      {
        type: "application/pdf",
      }
    );

    // ✅ MOBILE SHARE
    if (
      navigator.share &&
      navigator.canShare({
        files: [file],
      })
    ) {

      await navigator.share({
        title: "Quotation PDF",
        text: `Quotation #${order_id}`,
        files: [file],
      });

    } else {

      alert(
        "Sharing not supported on this device"
      );

    }

  } catch (err) {

    console.log(err);

  }

};

  return (
    <div className="p-4">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Order List</h1>

        <button
          className="md:hidden bg-gray-800 text-white px-3 py-2 rounded"
          onClick={() => setShowFilter(true)}
        >
          Filter ⚙️
        </button>
      </div>

      {/* DESKTOP SEARCH */}
      <div className="hidden md:flex gap-3 mb-4">
        <input
          type="text"
          placeholder="Search by name..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="border px-3 py-2 rounded"
        />
      </div>

      {/* ========================= */}
      {/* DESKTOP TABLE */}
      {/* ========================= */}
      {/* ========================= */}
{/* DESKTOP TABLE */}
{/* ========================= */}
<div className="hidden md:block overflow-x-auto">

  <div className="bg-white/70 backdrop-blur-xl rounded-2xl shadow-2xl border border-gray-200">

    {/* TOP CARDS */}
   <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">

  {/* TOTAL */}
  <div
    onClick={() =>
      setStatusFilter("All")
    }
    className={`
      bg-gradient-to-r
      from-blue-600
      to-blue-400
      text-white
      p-5
      rounded-2xl
      shadow-lg
      cursor-pointer
      transition
      hover:scale-105

      ${
        statusFilter === "All"
          ? "ring-4 ring-blue-200"
          : ""
      }
    `}
  >
    <p className="text-sm opacity-80">
      Total Orders
    </p>

    <h2 className="text-2xl font-bold mt-1">
      {orders.length}
    </h2>
  </div>

  {/* CONFIRMED */}
  <div
    onClick={() =>
      setStatusFilter(
        "Confirmed"
      )
    }
    className={`
      bg-gradient-to-r
      from-green-600
      to-green-400
      text-white
      p-5
      rounded-2xl
      shadow-lg
      cursor-pointer
      transition
      hover:scale-105

      ${
        statusFilter ===
        "Confirmed"
          ? "ring-4 ring-green-200"
          : ""
      }
    `}
  >
    <p className="text-sm opacity-80">
      Confirmed
    </p>

    <h2 className="text-2xl font-bold mt-1">
      {
        orders.filter(
          (o) =>
            o.status ===
            "Confirmed"
        ).length
      }
    </h2>
  </div>

  {/* PARTIAL */}
  <div
    onClick={() =>
      setStatusFilter(
        "Partial"
      )
    }
    className={`
      bg-gradient-to-r
      from-orange-500
      to-orange-300
      text-white
      p-5
      rounded-2xl
      shadow-lg
      cursor-pointer
      transition
      hover:scale-105

      ${
        statusFilter ===
        "Partial"
          ? "ring-4 ring-orange-200"
          : ""
      }
    `}
  >
    <p className="text-sm opacity-80">
      Partial
    </p>

    <h2 className="text-2xl font-bold mt-1">
      {
        orders.filter(
          (o) =>
            o.status ===
            "Partial"
        ).length
      }
    </h2>
  </div>

  {/* PENDING */}
  <div
    onClick={() =>
      setStatusFilter(
        "Pending"
      )
    }
    className={`
      bg-gradient-to-r
      from-yellow-500
      to-yellow-300
      text-white
      p-5
      rounded-2xl
      shadow-lg
      cursor-pointer
      transition
      hover:scale-105

      ${
        statusFilter ===
        "Pending"
          ? "ring-4 ring-yellow-200"
          : ""
      }
    `}
  >
    <p className="text-sm opacity-80">
      Pending
    </p>

    <h2 className="text-2xl font-bold mt-1">
      {
        orders.filter(
          (o) =>
            !o.status ||
            o.status ===
              "Pending"
        ).length
      }
    </h2>
  </div>

</div>

    <table className="w-full text-sm">

      {/* HEADER */}
      <thead className="bg-gradient-to-r from-gray-900 to-gray-700 text-white">
        <tr>
          <th className="p-4 text-left">#</th>
          <th className="p-4 text-left">Customer</th>
          <th className="p-4 text-left">Phone</th>
          <th className="p-4 text-left">Status</th>
          <th className="p-4 text-left">Date</th>
           <th className="p-4 text-left">Branch</th>
          <th className="p-4 text-center">Action</th>
        </tr>
      </thead>

      {/* BODY */}
      <tbody>
        {currentOrders.map((item, i) => (

          <tr
            key={item.order_id}
            className="border-b hover:bg-blue-50/40 transition duration-300 group"
          >

            {/* ID */}
            <td className="p-4 font-semibold text-gray-700">
              #{item.order_id}
            </td>

            {/* CUSTOMER */}
            <td className="p-4">

              <div className="flex items-center gap-3">

                {/* AVATAR */}
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 text-white flex items-center justify-center font-bold shadow">
                  {item.name?.charAt(0)}
                </div>

                <div>
                  <p className="font-semibold text-gray-800">
                    {item.name}
                  </p>

                  <p className="text-xs text-gray-400">
                    Customer
                  </p>
                </div>

              </div>

            </td>

            {/* PHONE */}
            <td className="p-4 text-gray-500">
              {item.phone}
            </td>

            {/* STATUS */}
            <td className="p-4">

             <span
  className={`px-3 py-1 rounded-full text-xs font-semibold
  ${
    item.status === "Invoiced"
      ? "bg-purple-100 text-purple-600"
      : item.status === "Confirmed"
      ? "bg-green-100 text-green-600"
      : item.status === "Partial"
      ? "bg-orange-100 text-orange-600"
      : "bg-yellow-100 text-yellow-600"
  }`}
>
  {item.status || "Pending"}
</span>

            </td>

            {/* DATE */}
            <td className="p-4 text-gray-400 text-sm">
              {item.created_at?.slice(0, 10)}
            </td>

            {/*Branch*/}
             <td className="p-4 text-gray-400 text-sm">
              {item.branch}
            </td>
            {/* ACTION */}
            <td className="p-4 text-center">

              <div className="flex justify-center gap-2">

                {/* VIEW */}
                <button
                  onClick={() =>
                    openOrderDetails(item.order_id)
                  }
                  className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-lg text-xs shadow-md hover:shadow-lg transition"
                >
                  View
                </button>

                {/* PDF */}
                <button
                  onClick={() =>
                    handlePrint(item.order_id)
                  }
                  className="bg-purple-500 hover:bg-purple-600 text-white px-3 py-1 rounded-lg text-xs shadow-md hover:shadow-lg transition"
                >
                  PDF
                </button>
                  <button
      onClick={() =>
        handleShare(item.order_id)
      }
      className="bg-gradient-to-r from-green-500 to-emerald-400 hover:scale-105 text-white px-3 py-2 rounded-xl text-xs shadow-md transition"
    >
      📤 Share
    </button>
                

                {/* CONFIRM */}
                {/* {item.status !== "Confirmed" && (
                  <button
                    onClick={() =>
                      openOrderDetails(item.order_id)
                    }
                    className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded-lg text-xs shadow-md hover:shadow-lg transition"
                  >
                    Confirm
                  </button>
                )} */}

              </div>

            </td>

          </tr>

        ))}
      </tbody>

    </table>

  </div>

</div>

      {/* ========================= */}
      {/* MOBILE CARD UI */}
      {/* ========================= */}
     {/* ========================= */}
{/* MOBILE UI */}
{/* ========================= */}
<div className="md:hidden flex flex-col gap-4 px-2">

  {/* TOP CARDS */}
  <div className="grid grid-cols-2 gap-3 mb-6">

    {/* TOTAL */}
    <div className="bg-gradient-to-r from-blue-600 to-blue-400 text-white p-3 rounded-2xl shadow">
      <p className="text-xs">Total Orders</p>
      <h2 className="text-lg font-bold">
        {orders.length}
      </h2>
    </div>

    {/* CONFIRMED */}
    <div className="bg-gradient-to-r from-green-600 to-green-400 text-white p-3 rounded-2xl shadow">
      <p className="text-xs">Confirmed</p>
      <h2 className="text-lg font-bold">
        {
          orders.filter(
            o => o.status === "Confirmed"
          ).length
        }
      </h2>
    </div>

    {/* PARTIAL */}
    <div className="bg-gradient-to-r from-orange-500 to-orange-300 text-white p-3 rounded-2xl shadow">
      <p className="text-xs">Partial</p>
      <h2 className="text-lg font-bold">
        {
          orders.filter(
            o => o.status === "Partial"
          ).length
        }
      </h2>
    </div>

    {/* PENDING */}
    <div className="bg-gradient-to-r from-yellow-500 to-yellow-300 text-white p-3 rounded-2xl shadow">
      <p className="text-xs">Pending</p>
      <h2 className="text-lg font-bold">
        {
          orders.filter(
            o =>
              !o.status ||
              o.status === "Pending"
          ).length
        }
      </h2>
    </div>

  </div>

  {/* ORDER CARDS */}
  {currentOrders.map((item, i) => (

    <div
      key={i}
      className="relative bg-white/80 backdrop-blur-xl border border-gray-200 rounded-2xl shadow-lg p-4 transition hover:shadow-xl"
    >

      {/* STATUS BADGE */}
      <span
        className={`absolute top-3 right-3 text-[10px] px-2 py-1 rounded-full font-semibold
        ${
          item.status === "Confirmed"
            ? "bg-green-100 text-green-600"
            : item.status === "Partial"
            ? "bg-orange-100 text-orange-600"
            : "bg-yellow-100 text-yellow-600"
        }`}
      >
        {item.status || "Pending"}
      </span>

      {/* HEADER */}
      <div className="flex items-center gap-3">

        {/* AVATAR */}
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 text-white flex items-center justify-center font-bold text-lg shadow">
          {item.name?.charAt(0) || "C"}
        </div>

        {/* NAME */}
        <div className="flex-1">
          <h3 className="font-semibold text-gray-800 text-sm">
            {item.name}
          </h3>

          <p className="text-xs text-gray-400">
            {item.order_no}
          </p>
           <p className="text-xs text-gray-400">
            Branch : {item.branch}
          </p>
        </div>

      </div>

      {/* DETAILS */}
      <div className="mt-3 grid grid-cols-2 gap-2 text-sm">

        <div>
          <p className="text-gray-400 text-xs">
            Phone
          </p>

          <p className="font-medium text-gray-700">
            {item.phone}
          </p>
        </div>

        <div className="text-right">
          <p className="text-gray-400 text-xs">
            Date
          </p>

          <p className="font-medium text-gray-700">
            {item.created_at?.slice(0, 10)}
          </p>
        </div>

      </div>

      {/* ACTIONS */}
      <div className="flex gap-2 mt-4">

        {/* VIEW */}
        <button
          onClick={() =>
            openOrderDetails(item.order_id)
          }
          className="flex-1 bg-gradient-to-r from-blue-500 to-blue-400 text-white py-2 rounded-xl shadow hover:shadow-md transition text-sm"
        >
          👁 View
        </button>

        {/* PDF */}
        <button
          onClick={() =>
            handlePrint(item.order_id)
          }
          className="flex-1 bg-gradient-to-r from-purple-500 to-pink-500 text-white py-2 rounded-xl shadow hover:shadow-md transition text-sm"
        >
          📄 PDF
        </button>
         <button
    onClick={() =>
      handleShare(item.order_id)
    }
    className="flex-1 bg-gradient-to-r from-green-500 to-emerald-400 text-white py-2 rounded-xl shadow text-sm"
  >
    📤 Share
  </button>

      {!["Confirmed", "Invoiced"].includes(item.status) && (
  <button
    onClick={() =>
      openOrderDetails(item.order_id)
    }
    className="bg-green-600 text-white px-3 py-2 rounded-xl shadow"
  >
    ✔
  </button>
)}

      </div>

    </div>

  ))}

</div>

      {/* PAGINATION */}
       <div className="flex justify-center items-center mt-6 gap-2 flex-wrap">

  {/* PREV */}
  <button
    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}
    className="px-3 py-2 rounded-lg border bg-white hover:bg-gray-100 disabled:opacity-50"
  >
    ◀
  </button>

  {/* PAGE NUMBERS */}
  {getPagination(currentPage, totalPages).map((page, index) => (

    page === "..." ? (
      <span key={index} className="px-2">...</span>
    ) : (
      <button
        key={index}
        onClick={() => setCurrentPage(page)}
        className={`px-3 py-2 rounded-lg border transition ${
          currentPage === page
            ? "bg-blue-500 text-white"
            : "bg-white hover:bg-gray-100"
        }`}
      >
        {page}
      </button>
    )
  ))}

  {/* NEXT */}
  <button
    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
    disabled={currentPage === totalPages}
    className="px-3 py-2 rounded-lg border bg-white hover:bg-gray-100 disabled:opacity-50"
  >
    ▶
  </button>

</div>

      {/* ========================= */}
      {/* MOBILE FILTER */}
      {/* ========================= */}
      <AnimatePresence>
        {showFilter && (
          <>
            <motion.div
              className="fixed inset-0 bg-black bg-opacity-50 z-[9998]"
              onClick={() => setShowFilter(false)}
            />

            <motion.div
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              className="fixed bottom-0 left-0 w-full bg-white p-4 rounded-t-2xl z-[9999]"
            >
              <input
                placeholder="Search"
                value={tempSearch}
                onChange={(e) => setTempSearch(e.target.value)}
                className="border w-full mb-3 p-2"
              />

              <button
                onClick={() => {
                  setSearch(tempSearch);
                  setShowFilter(false);
                  setCurrentPage(1);
                }}
                className="bg-blue-500 text-white w-full py-2 rounded"
              >
                Apply
              </button>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* ========================= */}
      {/* ORDER MODAL */}
      {/* ========================= */}
       {/* 🔥 MODAL */}
     {/* ========================= */}
{/* ORDER MODAL UI - SAME QUOTATION STYLE */}
{/* ========================= */}
<AnimatePresence>
  {fullOrder && (

    <motion.div
      className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[9999]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={() => setFullOrder(null)}
    >

      <motion.div
        className="bg-white/90 backdrop-blur-xl w-full max-w-4xl rounded-2xl shadow-2xl border border-gray-200 overflow-hidden"
        initial={{ scale: 0.9, y: 50 }}
        animate={{ scale: 1, y: 0 }}
        exit={{ scale: 0.9, y: 50 }}
        onClick={(e) => e.stopPropagation()}
      >

        {/* HEADER */}
        <div className="bg-gradient-to-r from-gray-900 to-gray-700 text-white p-5 flex justify-between items-center">

          <div>
            <h2 className="text-xl font-bold">
              {fullOrder?.order?.order_no}
            </h2>

            <p className="text-sm opacity-80">
              {fullOrder?.order?.name}
            </p>
          </div>

          <button
            onClick={() => setFullOrder(null)}
            className="text-white text-xl hover:scale-110 transition"
          >
            ✖
          </button>

        </div>

        {/* BODY */}
        <div className="p-5 space-y-4 max-h-[80vh] overflow-y-auto">

          {/* CUSTOMER INFO */}
          <div className="grid md:grid-cols-4 gap-4 bg-gray-50 p-4 rounded-xl">

            <div>
              <p className="text-xs text-gray-500">Phone</p>
              <p className="font-semibold">
                {fullOrder?.order?.phone}
              </p>
            </div>

            <div>
              <p className="text-xs text-gray-500">City</p>
              <p className="font-semibold">
                {fullOrder?.order?.address}
              </p>
            </div>

            <div>
              <p className="text-xs text-gray-500">Amount</p>
              <p className="font-bold text-blue-600">
                ₹{fullOrder?.order?.net_total}
              </p>
            </div>

            <div>
              <p className="text-xs text-gray-500">Status</p>

              <span className={`px-2 py-1 rounded text-xs font-semibold
                ${
                  fullOrder?.order?.status === "Confirmed"
                    ? "bg-green-100 text-green-600"
                    : fullOrder?.order?.status === "Partial"
                    ? "bg-orange-100 text-orange-600"
                    : "bg-yellow-100 text-yellow-600"
                }
              `}>
                {fullOrder?.order?.status || "Pending"}
              </span>

            </div>

          </div>

          {/* ACTION */}

                      {fullOrder?.order?.status === "Confirmed" && (

  // <button
  //   onClick={() =>
  //     createInvoice(
  //       fullOrder.order.order_id
  //     )
  //   }
  //   className="
  //     bg-indigo-600
  //     hover:bg-indigo-700
  //     text-white
  //     px-5
  //     py-2
  //     rounded-xl
  //     shadow-md
  //     transition
  //   "
  // >
  //   🧾 Create Invoice
  // </button>

  <button
onClick={()=>{

setInvoiceItems(fullOrder.items);

setShowInvoiceModal(true);

}}
className="bg-indigo-600 text-white px-5 py-2 rounded-xl"
>
🧾 Create Invoice
</button>

)}

{fullOrder?.order?.status === "Invoiced" && (

  <button
    onClick={() =>
      handleInvoicePrint(
        fullOrder.order.order_id
      )
    }
    className="
      bg-green-600
      hover:bg-green-700
      text-white
      px-5
      py-2
      rounded-xl
    "
  >
    📄 Invoice PDF
  </button>

)}

        {!["Confirmed", "Invoiced"].includes(
  fullOrder?.order?.status
) && (

  <div className="flex justify-end">

    <button
      onClick={() =>
        confirmOrder(fullOrder.order.order_id)
      }
      className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-xl shadow-md transition"
    >
      ✅ Confirm Selected
    </button>

  </div>

)}

          {/* ITEMS */}
         {/* PRODUCTS */}
<div className="space-y-3">

  {fullOrder.items.map(item => (

    <div
      key={item.product_id}
      className="bg-white border border-gray-200 rounded-2xl shadow-md p-3"
    >

      <div className="flex gap-3 items-start">

        {/* CHECKBOX */}
        <div className="pt-2">
          <input
            type="checkbox"
            checked={
              selectedItems.includes(item.product_id)
              || item.confirmed === 1
            }
            disabled={item.confirmed === 1}
            onChange={() =>
              handleSelectItem(item.product_id)
            }
            className="w-4 h-4 md:w-5 md:h-5"
          />
        </div>

        {/* IMAGE */}
        <img
          src={
            item.image
              ? `https://akceramicworldadmin.unitdtechnologies.com/uploads/${item.image}`
              : "https://via.placeholder.com/100"
          }
          alt={item.product_name}
          className="
            w-20 h-20
            md:w-24 md:h-24
            rounded-xl
            object-cover
            border
            flex-shrink-0
          "
        />

        {/* CONTENT */}
        <div className="flex-1 min-w-0">

          <div className="flex justify-between gap-2">

            <h4
              className="
                font-semibold
                text-[15px]
                md:text-lg
                text-gray-800
                leading-5
                break-words
              "
            >
              {item.product_name}
            </h4>

            <div className="text-right flex-shrink-0">
              <p className="text-[11px] text-gray-400">
                Amount
              </p>

              <p className="text-blue-600 font-bold text-lg">
                ₹{item.item_amount}
              </p>
            </div>

          </div>

          {/* DETAILS */}
          <div className="mt-2 flex flex-wrap gap-3 text-sm">

            <div>
              <p className="text-gray-400 text-[11px]">
                Qty
              </p>

              <p className="font-medium text-gray-700">
                {item.qty}
              </p>
            </div>
             <div>
              <p className="text-gray-400 text-[11px]">
                Pcs
              </p>

              <p className="font-medium text-gray-700">
                {item.pcs}
              </p>
            </div>

            <div>
              <p className="text-gray-400 text-[11px]">
                Area
              </p>

              <p className="font-medium text-gray-700">
                {item.total_area} Sq.ft
              </p>
            </div>
              <div>
              <p className="text-gray-400 text-[11px]">
                Price
              </p>

              <p className="font-medium text-gray-700">
                {item.price} RS
              </p>
            </div>

          </div>

          {/* CONFIRMED */}
          {item.confirmed === 1 && (

            <div className="mt-2">
              <span className="bg-green-100 text-green-600 px-2 py-1 rounded-full text-[10px] font-semibold">
                Confirmed
              </span>
            </div>

          )}

          {/* VIEW DETAILS */}
       {/* ACTION BUTTONS */}
<div className="flex gap-2 mt-3 flex-wrap">

  {/* VIEW DETAILS */}
  <button
    onClick={() =>
      setOpenId(
        openId === item.product_id
          ? null
          : item.product_id
      )
    }
    className="
      bg-blue-500
      hover:bg-blue-600
      text-white
      px-3
      py-2
      rounded-xl
      text-xs
      md:text-sm
      font-medium
      shadow
      transition
    "
  >
    {openId === item.product_id
      ? "Hide Details"
      : "View Details"}
  </button>
  {
  item.status === "Invoiced" && (
    <span className="
      bg-purple-100
      text-purple-600
      px-3 py-1
      rounded-full
      text-xs
      font-semibold
    ">
      Invoice Created
    </span>
  )
}

 {/* RETURN PRODUCT */}
{fullOrder?.order?.status === "Confirmed" && (

  <button
    onClick={() => {

      setReturnItem(item);

      setReturnQty(item.qty || 0);

      setReturnPcs(item.pcs || 0);

      setShowReturnModal(true);

    }}
    className="
      bg-red-500
      hover:bg-red-600
      text-white
      px-3
      py-2
      rounded-xl
      text-xs
      md:text-sm
      font-medium
      shadow
      transition
    "
  >
    ↩ Return Product
  </button>

)}

</div>

          {/* HISTORY */}
          {openId === item.product_id && (

            <div
              className="
                mt-3
                bg-gray-100
                rounded-xl
                p-2
                text-[11px]
                md:text-xs
              "
            >

              {item.history.map(h => (

                <div
                  key={h.order_item_id}
                  className="
                    flex
                    flex-wrap
                    gap-2
                    text-gray-700
                    border-b
                    last:border-0
                    py-1
                  "
                >
                  <span>L: {h.length}</span>
                  <span>W: {h.width}</span>
                  <span>H: {h.height}</span>
                  <span>{h.total_area} Sq.ft</span>
                </div>

              ))}

            </div>

          )}

        </div>

      </div>

    </div>

  ))}

</div>
          {/* TOTAL */}
          <div className="flex justify-end border-t pt-4">

            <div className="text-right">
              <p className="text-gray-500 text-sm">
                Total Amount
              </p>

              <h2 className="text-2xl font-bold text-blue-600">
                ₹{fullOrder?.order?.net_total}
              </h2>
            </div>

          </div>

        </div>

      </motion.div>

    </motion.div>

  )}
</AnimatePresence>

{/* ========================= */}
{/* CREATE INVOICE MODAL */}
{/* ========================= */}

<AnimatePresence>

{showInvoiceModal && (

<motion.div
className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[99999]"
initial={{ opacity:0 }}
animate={{ opacity:1 }}
exit={{ opacity:0 }}
>

<motion.div
initial={{ scale:0.9,y:40 }}
animate={{ scale:1,y:0 }}
exit={{ scale:0.9,y:40 }}
className="bg-white w-full max-w-5xl rounded-3xl shadow-2xl overflow-hidden"
>

{/* HEADER */}

<div className="bg-gradient-to-r from-indigo-600 to-blue-600 text-white p-5 flex justify-between">

<div>

<h2 className="text-2xl font-bold">
Create Invoice
</h2>

<p>
{fullOrder?.order?.name}
</p>

</div>

<button
onClick={()=>{
setShowInvoiceModal(false);
}}
className="text-2xl"
>
✕
</button>

</div>

{/* BODY */}

<div className="p-6 max-h-[75vh] overflow-y-auto">

<table className="w-full border">

<thead className="bg-gray-100">

<tr>

<th className="p-2">
Product
</th>

<th>
Qty
</th>

<th>
PCS
</th>

<th>
Rate
</th>

<th>
Amount
</th>

<th>
Action
</th>

</tr>

</thead>

<tbody>

{invoiceItems.map((item,index)=>{

const amount=
(Number(item.qty)*Number(item.price));

return(

<tr key={index} className="border-b">

<td className="p-2">
{item.product_name}
</td>

<td>

<input
type="number"
value={item.qty}
className="border rounded w-20 p-1"
onChange={(e)=>{

const arr=[...invoiceItems];

arr[index].qty=e.target.value;

setInvoiceItems(arr);

}}
/>

</td>

<td>

<input
type="number"
value={item.pcs}
className="border rounded w-20 p-1"
onChange={(e)=>{

const arr=[...invoiceItems];

arr[index].pcs=e.target.value;

setInvoiceItems(arr);

}}
/>

</td>

<td>

<input
type="number"
value={item.price}
className="border rounded w-24 p-1"
onChange={(e)=>{

const arr=[...invoiceItems];

arr[index].price=e.target.value;

setInvoiceItems(arr);

}}
/>

</td>

<td className="font-bold">

₹{amount}

</td>

<td>

<button
className="bg-red-500 text-white px-3 py-1 rounded"
onClick={()=>{

setInvoiceItems(

invoiceItems.filter((_,i)=>i!==index)

);

}}
>

Remove

</button>

</td>

</tr>

)

})}

</tbody>

</table>

{/* GST */}

<div className="grid grid-cols-4 gap-4 mt-8">

<div>

<label className="font-semibold">

GST %

</label>

<input
type="number"
value={gst}
onChange={(e)=>setGst(e.target.value)}
className="border rounded w-full p-2"
/>

</div>

<div>

<label>

CGST

</label>

<input
readOnly
value={Number(gst)/2}
className="border rounded w-full p-2 bg-gray-100"
/>

</div>

<div>

<label>

SGST

</label>

<input
readOnly
value={Number(gst)/2}
className="border rounded w-full p-2 bg-gray-100"
/>

</div>

</div>
<div className="grid grid-cols-2 gap-4 mt-6">

  <div>
    <label className="block font-semibold mb-1">
      Vehicle No
    </label>

    <input
      type="text"
      placeholder="Enter Vehicle Number"
      value={vehicleNo}
      onChange={(e) => setVehicleNo(e.target.value.toUpperCase())}
      className="border rounded w-full p-2"
    />
  </div>

</div>
{/* TOTAL */}

<div className="mt-8 flex justify-end">

<div className="w-80 space-y-3">

<div className="flex justify-between">

<span>

Subtotal

</span>

<span>

₹{

invoiceItems.reduce(

(a,b)=>

a+

(Number(b.qty)*Number(b.price))

,0)

}

</span>

</div>

<div className="flex justify-between">

<span>

GST

</span>

<span>

₹{

(

invoiceItems.reduce(

(a,b)=>

a+

(Number(b.qty)*Number(b.price))

,0)

*

Number(gst)

/

100

).toFixed(2)

}

</span>

</div>

<div className="flex justify-between text-xl font-bold">

<span>

Grand Total

</span>

<span>

₹{

(

invoiceItems.reduce(

(a,b)=>

a+

(Number(b.qty)*Number(b.price))

,0)

+

(

invoiceItems.reduce(

(a,b)=>

a+

(Number(b.qty)*Number(b.price))

,0)

*

Number(gst)

/

100

)

).toFixed(2)

}

</span>

</div>

</div>

</div>

</div>

{/* FOOTER */}

<div className="border-t p-5 flex justify-end gap-3">

<button
onClick={()=>setShowInvoiceModal(false)}
className="px-6 py-2 border rounded-xl"
>

Cancel

</button>

<button
  onClick={() => {
   

    createInvoice(
      fullOrder?.order?.order_id,
      invoiceItems,
      gst,
      vehicleNo
    );
  }}
  className="bg-indigo-600 text-white px-6 py-2 rounded-xl"
>
  Create Invoice
</button>

</div>

</motion.div>

</motion.div>

)}

</AnimatePresence>

{/* RETURN MODAL */}
{/* ========================= */}

<AnimatePresence>

  {showReturnModal && (() => {

    // =========================
    // PCS PER BOX
    // =========================

    const pcsPerBox =
      Number(returnItem?.pcs_per_box || 1);

    // =========================
    // SOLD VALUES
    // =========================

    const soldQty =
      Number(returnItem?.qty || 0);

    const soldPcs =
      Number(returnItem?.pcs || 0);

    // =========================
    // RETURNED VALUES
    // =========================

    const returnedQty =
      Number(returnItem?.return_qty || 0);

    const returnedPcs =
      Number(returnItem?.return_pcs || 0);

    // =========================
    // TOTAL PCS
    // =========================

    const soldTotalPcs =
      (soldQty * pcsPerBox) +
      soldPcs;

    const returnedTotalPcs =
      (returnedQty * pcsPerBox) +
      returnedPcs;

    // =========================
    // BALANCE TOTAL PCS
    // =========================

    let balanceTotalPcs =
      soldTotalPcs -
      returnedTotalPcs;

    // NEVER NEGATIVE

    if (balanceTotalPcs < 0) {
      balanceTotalPcs = 0;
    }

    // =========================
    // FINAL BALANCE
    // =========================

    const balanceQty =
      Math.floor(
        balanceTotalPcs /
        pcsPerBox
      );

    const balancePcs =
      balanceTotalPcs %
      pcsPerBox;

    // =========================
    // INPUT VALUES
    // =========================

    const enteredQty =
      Number(returnQty || 0);

    const enteredPcs =
      Number(returnPcs || 0);

    // =========================
    // RETURN PCS
    // =========================

    const enteredTotalPcs =
      (enteredQty * pcsPerBox) +
      enteredPcs;

    // =========================
    // AFTER RETURN
    // =========================

    let afterReturnPcs =
      balanceTotalPcs -
      enteredTotalPcs;

    if (afterReturnPcs < 0) {
      afterReturnPcs = 0;
    }

    const afterQty =
      Math.floor(
        afterReturnPcs /
        pcsPerBox
      );

    const afterPcs =
      afterReturnPcs %
      pcsPerBox;

    // =========================
    // DISABLE BUTTON
    // =========================

    const disableReturn =
      enteredTotalPcs <= 0 ||
      enteredTotalPcs >
        balanceTotalPcs;

    return (

      <motion.div
        className="
          fixed
          inset-0
          bg-black/60
          backdrop-blur-sm
          flex
          items-center
          justify-center
          z-[99999]
          p-3
        "
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >

        <motion.div
          initial={{
            scale: 0.8,
            y: 50
          }}
          animate={{
            scale: 1,
            y: 0
          }}
          exit={{
            scale: 0.8,
            y: 50
          }}
          transition={{
            duration: 0.25
          }}
          className="
            bg-white
            w-full
            max-w-md
            rounded-3xl
            shadow-2xl
            overflow-hidden
          "
        >

          {/* HEADER */}

          <div className="
            bg-gradient-to-r
            from-red-500
            to-red-400
            p-5
            text-white
            flex
            justify-between
            items-center
          ">

            <div>

              <h2 className="
                text-xl
                font-bold
              ">
                Return Product
              </h2>

              <p className="
                text-sm
                opacity-90
                mt-1
              ">
                {returnItem?.product_name}
              </p>

            </div>

            <button
              onClick={() =>
                setShowReturnModal(false)
              }
              className="
                p-2
                rounded-full
                hover:bg-white/20
              "
            >
              <X size={20} />
            </button>

          </div>

          {/* BODY */}

          <div className="
            p-5
            space-y-5
          ">

            {/* PRODUCT */}

            <div className="
              flex
              gap-3
              items-center
            ">

              <img
                src={`https://akceramicworldadmin.unitdtechnologies.com/uploads/${returnItem?.image}`}
                alt=""
                className="
                  w-20
                  h-20
                  rounded-2xl
                  object-cover
                  border
                "
              />

              <div className="flex-1">

                <h3 className="
                  font-semibold
                  text-gray-800
                ">
                  {returnItem?.product_name}
                </h3>

                <p className="
                  text-sm
                  text-gray-500
                ">
                  ₹{returnItem?.price}
                </p>

                <p className="
                  text-xs
                  text-gray-400
                  mt-1
                ">
                  Code :
                  {returnItem?.product_code}
                </p>

              </div>

            </div>

            {/* STATUS */}

            <div className="
              grid
              grid-cols-3
              gap-3
            ">

              {/* SOLD */}

              <div className="
                bg-blue-50
                rounded-2xl
                p-3
                text-center
              ">

                <p className="
                  text-xs
                  text-gray-500
                ">
                  Sold
                </p>

                <h3 className="
                  text-lg
                  font-bold
                  text-blue-600
                ">
                  {soldQty}
                </h3>

                <p className="
                  text-xs
                  text-gray-400
                ">
                  Qty
                </p>

                <h4 className="
                  font-semibold
                  mt-1
                ">
                  {soldPcs}
                </h4>

                <p className="
                  text-xs
                  text-gray-400
                ">
                  PCS
                </p>

              </div>

              {/* RETURNED */}

              <div className="
                bg-red-50
                rounded-2xl
                p-3
                text-center
              ">

                <p className="
                  text-xs
                  text-gray-500
                ">
                  Returned
                </p>

                <h3 className="
                  text-lg
                  font-bold
                  text-red-500
                ">
                  {returnedQty}
                </h3>

                <p className="
                  text-xs
                  text-gray-400
                ">
                  Qty
                </p>

                <h4 className="
                  font-semibold
                  mt-1
                ">
                  {returnedPcs}
                </h4>

                <p className="
                  text-xs
                  text-gray-400
                ">
                  PCS
                </p>

              </div>

              {/* BALANCE */}

              <div className="
                bg-green-50
                rounded-2xl
                p-3
                text-center
              ">

                <p className="
                  text-xs
                  text-gray-500
                ">
                  Balance
                </p>

                <h3 className="
                  text-lg
                  font-bold
                  text-green-600
                ">
                  {balanceQty}
                </h3>

                <p className="
                  text-xs
                  text-gray-400
                ">
                  Qty
                </p>

                <h4 className="
                  font-semibold
                  mt-1
                ">
                  {balancePcs}
                </h4>

                <p className="
                  text-xs
                  text-gray-400
                ">
                  PCS
                </p>

              </div>

            </div>

            {/* LIVE CALCULATION */}

            <div className="
              bg-gray-50
              rounded-2xl
              p-4
              border
            ">

              <div className="
                flex
                justify-between
                text-sm
                mb-2
              ">

                <span className="text-gray-500">
                  Returning
                </span>

                <span className="
                  font-bold
                  text-red-500
                ">
                  {enteredQty} Box
                  {enteredPcs} PCS
                </span>

              </div>

              <div className="
                flex
                justify-between
                text-sm
              ">

                <span className="text-gray-500">
                  Remaining
                </span>

                <span className="
                  font-bold
                  text-green-600
                ">
                  {afterQty} Box
                  {afterPcs} PCS
                </span>

              </div>

            </div>

            {/* INPUTS */}

            <div className="
              grid
              grid-cols-2
              gap-3
            ">

              {/* RETURN QTY */}

              <div>

                <label className="
                  text-sm
                  font-semibold
                  text-gray-700
                  block
                  mb-2
                ">
                  Return Qty
                </label>

                <input
                  type="number"
                  min="0"
                  max={balanceQty}
                  value={returnQty}
                  onChange={(e)=>
                    setReturnQty(
                      e.target.value
                    )
                  }
                  className="
                    w-full
                    border
                    rounded-2xl
                    px-4
                    py-3
                    outline-none
                    focus:border-red-400
                  "
                />

              </div>

              {/* RETURN PCS */}

              <div>

                <label className="
                  text-sm
                  font-semibold
                  text-gray-700
                  block
                  mb-2
                ">
                  Return PCS
                </label>

                <input
                  type="number"
                  min="0"
                  max={pcsPerBox - 1}
                  value={returnPcs}
                  onChange={(e)=>
                    setReturnPcs(
                      e.target.value
                    )
                  }
                  className="
                    w-full
                    border
                    rounded-2xl
                    px-4
                    py-3
                    outline-none
                    focus:border-red-400
                  "
                />

              </div>

            </div>

          </div>

          {/* FOOTER */}

          <div className="
            p-5
            border-t
            flex
            gap-3
          ">

            <button
              onClick={() =>
                setShowReturnModal(false)
              }
              className="
                flex-1
                border
                border-gray-300
                py-3
                rounded-2xl
                font-semibold
              "
            >
              Cancel
            </button>
{/* RETURN BUTTON */}
<button
  disabled={disableReturn}
  onClick={async () => {

    // =========================
    // PCS CALCULATION
    // =========================

    const pcsPerBox =
      Number(returnItem?.pcs_per_box || 1);

    const enteredQty =
      Number(returnQty || 0);

    const enteredPcs =
      Number(returnPcs || 0);

    // RETURN TOTAL PCS
    const returnTotalPcs =
      (enteredQty * pcsPerBox) +
      enteredPcs;

    // SOLD
    const soldQty =
      Number(returnItem?.qty || 0);

    const soldPcs =
      Number(returnItem?.pcs || 0);

    // RETURNED
    const returnedQty =
      Number(returnItem?.return_qty || 0);

    const returnedPcs =
      Number(returnItem?.return_pcs || 0);

    // SOLD TOTAL PCS
    const soldTotalPcs =
      (soldQty * pcsPerBox) +
      soldPcs;

    // RETURNED TOTAL PCS
    const returnedTotalPcs =
      (returnedQty * pcsPerBox) +
      returnedPcs;

    // BALANCE PCS
    const balanceTotalPcs =
      soldTotalPcs -
      returnedTotalPcs;

    // BALANCE BOX + PCS
    const balanceQty =
      Math.floor(
        balanceTotalPcs / pcsPerBox
      );

    const balancePcs =
      balanceTotalPcs % pcsPerBox;

    // =========================
    // VALIDATION
    // =========================

    if (returnTotalPcs <= 0) {

      alert("Enter return value");

      return;

    }

    if (
      returnTotalPcs >
      balanceTotalPcs
    ) {

      alert(
        `Only ${balanceQty} Box ${balancePcs} PCS available`
      );

      return;

    }

    // =========================
    // API
    // =========================

    try {

      const res =
        await api.post(
          "/Product/productReturn",
          {
            order_id:
              returnItem.order_id,

            order_item_id:
              returnItem.order_item_id,

            product_id:
              returnItem.product_id,

            return_qty:
              enteredQty,

            return_pcs:
              enteredPcs,

            pcs_per_box:
              pcsPerBox,

            reason:
              "Customer Return"
          }
        );

      alert(res.data.message);

      // REFRESH ORDER
      const updated =
        await api.get(
          `/order/getFullOrderDetails/${returnItem.order_id}`
        );

      setFullOrder(updated.data);

      setShowReturnModal(false);

      setReturnQty("");
      setReturnPcs("");

    } catch (err) {

      console.log(err);

      alert("Return Failed");

    }

  }}

  className={`
    flex-1
    py-3
    rounded-2xl
    font-semibold
    text-white
    transition

    ${
      disableReturn
        ? "bg-gray-300 cursor-not-allowed"
        : "bg-red-500 hover:bg-red-600"
    }
  `}
>

  {
    disableReturn
      ? "No Balance"
      : `Return ${returnQty || 0} Box ${returnPcs || 0} PCS`
  }

</button>
          </div>

        </motion.div>

      </motion.div>

    );

  })()}

</AnimatePresence>

    </div>
  );
}